import React, { useRef } from 'react'
import { useRouter } from 'next/router'
import SEO from '../seo-head/seo-head'
import { listingImageOverride } from '../../lib/listing-image-overrides'
import { listingGalleryOverride } from '../../lib/listing-gallery-overrides'
import ArticleContents from '../article-contents/article-contents.component'
import SectionOne from '../section-one/section-one.jsx'
import BlogContentSection from '../blog-content-section/blog-content-section.component'
import { ListingInfoPanel } from '../listing-info-panel/listing-info-panel.component'
import VenueGallery from '../venue-gallery/venue-gallery.component'
import { Header } from '../header/header'
import { Footer } from '../footer/footer.component.jsx'
import { base } from '../../styles/base/_allBase.styles'
import { ArticleMain, BodyWrap, PanelWrap } from './article-layout.styles'
const { GridItem_HeaderSection, GridContainer_Page_Layout, Page_Main_Grid_Container } = base

function buildEditorialLayoutPlan(body) {
  let imageIndex = 0

  return body.map((section, index) => {
    if (section.image) {
      const layout = imageIndex > 0 && imageIndex % 3 === 2 ? 'feature' : 'split'
      imageIndex += 1
      return layout
    }

    if (index === 0) return 'intro'
    if (index === body.length - 1) return 'closing'
    return 'prose'
  })
}

// variant: 'business' | 'article'
export const ArticleLayout = ({ doc, seo, jsonLd = [], variant = 'article', afterBody = null }) => {
  const router = useRouter()
  const sectionOneRef = useRef()
  const hero = { _key: `${doc._id}-hero`, header: doc.location || doc.title, subheader: doc.tagline || doc.subtitle, photo: doc.mainImage, photoOverride: listingImageOverride(doc) }
  const body = doc.body || doc.sections || []
  const editorialLayouts = variant === 'article'
    ? buildEditorialLayoutPlan(body)
    : body.map(() => 'business')
  return (
    <GridContainer_Page_Layout>
      <SEO seo={seo} router={router} header={hero} type={variant === 'article' ? 'article' : 'website'} />
      {jsonLd.map((data, i) => (
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
      ))}
      <GridItem_HeaderSection><header ref={sectionOneRef}><Header /></header></GridItem_HeaderSection>
      <main>
        <Page_Main_Grid_Container>
          <SectionOne header={hero} variant={variant === 'business' ? 'venue' : 'guide'} />
          <ArticleMain $variant={variant}>
            {variant === 'business' && (
              <PanelWrap><ListingInfoPanel listing={doc} /></PanelWrap>
            )}
            <BodyWrap $variant={variant}>
              {variant === 'article' && <ArticleContents doc={doc} sections={body} />}
              {body.map((section, i) => (
                <BlogContentSection
                  key={section._key || i}
                  data={section}
                  index={i}
                  total={body.length}
                  layout={editorialLayouts[i]}
                  variant={variant}
                  numberSections={doc.numberSections !== false}
                />
              ))}
              {afterBody}
              {variant === 'business' && (
                <VenueGallery
                  key={doc._id}
                  images={listingGalleryOverride(doc) || doc.otherLocationImages}
                  mainImage={doc.mainImage}
                  venueName={doc.location}
                  listing={doc}
                />
              )}
            </BodyWrap>
          </ArticleMain>
          <Footer />
        </Page_Main_Grid_Container>
      </main>
    </GridContainer_Page_Layout>
  )
}
export default ArticleLayout
